/**
 * Group an activation PIN into threes, the way the admin panel and the season
 * tickets show it ("3W97SFNNP" -> "3W9-7SF-NNP"). The token is stored without
 * separators, so this is display-only.
 * @param {string} code - Raw activation token
 * @returns {string}
 */
export default (code) => {
  if (!code) return '';

  const clean = String(code).replace(/[^A-Za-z0-9]/g, '').toUpperCase();

  return clean.match(/.{1,3}/g)?.join('-') ?? clean;
};
